import React, { useState, forwardRef } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import api from 'services/api';
import { useNavigate } from 'react-router-dom';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function UpdateToDriverDialogComponent(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const handleUpdate = async () => {
    await api.put(`driver/${props.cpfID}/turn-on`);
    setOpen(false);
    navigate(`/motoristas/${props.cpfID}`);
  };

  const handleClose = () => {
    props.setProps((prev) => ({ ...prev, cpf: '' }));
    props.setCpfID(null);
    props.setCpfFound(null);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}>
        <DialogTitle>O CPF já Cadastrado!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            O Cpf {props.cpf} já está cadastrado como transportador, deseja utilizar os mesmos dados
            para atualizá-lo como motorista?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Não</Button>
          <Button onClick={handleUpdate}>Sim</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
